<template>
  <section class="d-flex flex-column h-full bg-documentGray">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
      staticMode="true"
    ></TopAppBar>

    <div class="flex-grow-1 scroll-y">
    <HelpDeskList></HelpDeskList>
    <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
    </div>


  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import HelpDeskList from '@/components/helpDesk/List'

export default {
    name: 'learn',

    data() {
        return {
            // title
            leftBtnMethod: () => { this.$router.go(-1)}
        }
    },
    components: {
        TopAppBar,
        HelpDeskList
    },

    mixins: [topAppBarMixin],

    watch: {
        '$route' (to, from) {

        }
    },

    mounted() {
        this.setTopAppBarHomeSearch(this.$t('1497'))
    },
}
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
      border-radius: 4px;
      box-shadow: 0 1px 3px 0 var(--Shadow1);
      background-color: var(--DocumentWhite);
  }

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid var(--Divider);
}
.b-radius2 {
  border-radius: 2px;
}
.l-spacing36 {
  letter-spacing: -0.36px;
}
.font-16 {
  font-size: 16px;
}
.bg-paymentBlue3 {
  background-color: var(--ContentBlue);
}
.queryCount {
  border-radius: 50%;
  line-height: 1.7;
}
.font-11 {
  font-size: 11px !important;
}
#tab1, #tab2{
    margin-top: 112px;
}
</style>
